module.exports = __webpack_public_path__ + "media/images/development-70bdf370d96b0f7d75f125895fda0873.png";